const styles = {
  header: {
    display: 'flex',
    flexDirection: 'row'
  },
  title: {
    marginTop: 7,
    marginRight: 24
  },
  notesChipList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  }
}

export default styles
